﻿module.exports = {
    "id": "da",
    "label": "Dansk",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":           "Ugyldigt Link",
        "INVALID_LINK_TEXT":            "Brug venligst linket i din e-mail for at blive afmeldt vores mailinglister.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "Er du sikker på, at du vil afmelde denne e-mail fra vores mailinglister?",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "Klik på knappen \"Afmeld\" nedenfor for at bekræfte.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "Du er nu <b>afmeldt</b> vores mailinglister.",
        "UNSUBSCRIBED_IN_ERROR":        "Hvis du er blevet afmeldt ved en fejl, skal du klikke på <a href='/resubscribe' class='resubscribe'>tilmeld igen</a>-linket.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>Annulleret.</b> Du er stadig <b>tilmeldt</b> vores mailinglister.",
        "THANK_YOU_FOR_CONTINUING":     "Tak fordi du fortsat deltager i vores undersøgelser.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "Denne e-mail er allerede <b>afmeldt</b> fra vores mailinglister.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":  "Klik på knappen \"Tilmeld Igen\" nedenfor for at tilmelde dig vores mailinglister igen.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "Du er nu <b>tilmeldt</b> vores mailinglister igen.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "Du er allerede <b>tilmeldt</b> vores mailinglister.",
        "THANK_YOU_FOR_PARTICIPATING":  "Tak fordi du deltager i vores undersøgelser.",
        "CHECKING":                     "Kontrollerer...",
        "UNSUBSCRIBE":                  "Afmeld",
        "RESUBSCRIBE":                  "Tilmeld Igen",
        "EMAIL":                        "E-mail",
        "CANCEL":                       "Annuller"
    }
};

